import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaPageTitleComponent} from './la-page-title.component';
import {LaSpacerModule} from '../spacer/la-spacer.module';

@NgModule({
  imports: [
    CommonModule,
    LaSpacerModule
  ],
  declarations: [LaPageTitleComponent],
  exports: [LaPageTitleComponent]
})
export class LaPageTitleModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaPageTitleModule,
      providers: []
    }
  }
}
